import Vue from 'vue'
import {router} from './router';
import store from './store';
import {Toast} from 'vant';

const whiteList = ['/500'];

router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.path) !== -1) {
    return next();
  }
  const ua = navigator.userAgent;
  let disableWxAuth = parseInt(to.query.disableWxAuth);
  if (isNaN(disableWxAuth)) {
    disableWxAuth = parseInt(sessionStorage.getItem('disableWxAuth'));
    if (isNaN(disableWxAuth)) {
      disableWxAuth = 0;
    }
  }
  sessionStorage.setItem('disableWxAuth', disableWxAuth);
  // 闽政通小程序判断
  if (/mzt/.test(ua)) {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
      duration: 0
    });
    try {
      setTimeout(() => {
        app.link.getLoginInfo((res) => {
          let data = {
            userId: res.userId,
            userToken: res.userToken
          };
          // 获取闽政通用户信息并保存到当前系统
          store.dispatch("getMztUserInfo", data).then(() => {
            next();
          }).catch((err) => {
            store.dispatch("addErrorLog", err);
            Toast.clear();
            next({ path: '/500' });
          });
        }, (err) => {
          store.dispatch("addErrorLog", err);
          next();
        });
      }, 300);
    } catch (err) {
      store.dispatch("addErrorLog", err);
      next();
    }
  } else if (/MicroMessenger/.test(ua) && !disableWxAuth) {
    // 微信浏览器判断
    let openId = sessionStorage.getItem('openId');
    if (!openId) {
      openId = to.query.openId || "";
      if (!openId) {
        const redirectUri = encodeURIComponent(window.location.href);
        window.location.href = `${window.g.url}/wx/account/authorize/userInfo?redirectUri=${redirectUri}`;
        return;
      } else {
        sessionStorage.setItem('openId', openId);
        store.dispatch("getWxUserInfo", {openId: openId}).then(() => {
          next();
        }).catch((err) => {
          store.dispatch("addErrorLog", err);
          Toast.clear();
          next({ path: '/500' });
        });
      }
    } else {
      store.dispatch("getWxUserInfo", {openId: openId}).then(() => {
        next();
      }).catch((err) => {
        store.dispatch("addErrorLog", err);
        Toast.clear();
        next({ path: '/500' });
      });
    }
  } else if (/AlipayClient/.test(ua)) {
    next();
  } else if (to.query.disableWxAuth === undefined) {
    let toQuery = JSON.parse(JSON.stringify(from.query));
    next({ path: to.path, query: toQuery });
  } else {
    next();
  }
});
router.afterEach(() => {
  Toast.clear();
});



// WEBPACK FOOTER //
// ./src/permission.js